export const recordIsActive = ({ inactive, status }) => {
  if (inactive) {
    return false
  }

  return String(status).toLowerCase() !== 'inactive'
}



// WEBPACK FOOTER //
// ./src/ui/record-display-list/helpers.js